// src/config.js
export default {
    SITE_NAME: 'amatourflits',
    // other settings
};